import About from './About';
import Resume from './Resume';
import Navbar from "./Navbar";
import Skills from "./Skills";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const Home = () => {
  return (
    <Router>
      <Navbar />
      <div className="main__section">
        <div className="container">
          <Switch>
            <Route path='/home/about' component={About} />
            <Route path='/home/resume' component={Resume} />
            <Route path='/home/skills' component={Skills} />
            <Route path='/home' component={About} />
          </Switch>
        </div>
      </div>
    </Router>
  );
};

export default Home;
